import React, { useEffect, useState } from "react"
import { View, Text, StyleSheet, TouchableOpacity, ScrollView, Image, ActivityIndicator, Platform } from "react-native"
// import { useNavigation } from "@react-navigation/native"
import AsyncStorage from "@react-native-async-storage/async-storage"
import { useDispatch } from "react-redux"
import { loginActions } from "./slices/authSlice"
import API_PATHS from '../src/apiCalls/ApiPath'
import TopGreenHeader from "./screens/Common/TopGreenHeader"

const Notification = ({ navigation }) => {
  // const navigation = useNavigation()
  const dispatch = useDispatch()
  const [notifications, setNotifications] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState("")

  useEffect(() => {
    fetchNotifications()
  }, [])

  const fetchNotifications = async () => {
    try {
      const token = await AsyncStorage.getItem("token")
      if (!token) {
        //console.error("No token found")
        setError("Authentication error. Please log in again.")
        return
      }
      //console.log("Fetching notifications with token:", token)
      const response = await fetch(`${API_PATHS.BASE_URL}${API_PATHS.GET_NOTIFICATIONS}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          pageno: 1,
          count: 20,
        }),
      })

      if (!response.ok) {
        //console.error("API response not OK:", response.status, response.statusText)
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const result = await response.json()
      //console.log("API response:", result)

      if (result.Success === 1) {
        setNotifications(result.Data)
      } else {
        //console.error("API returned success false:", result.Message)
        setError(result.Message || "Failed to fetch notifications")
      }
    } catch (err) {
      //console.error("Error in fetchNotifications:", err)
      setError("An error occurred while fetching notifications")
    } finally {
      setLoading(false)
    }
  }

  const handlePress = (item) => {
    if (item.recurringId !== null) {
      navigation.navigate("RecurringDetails", { recurringId: item.recurringId });
    }
    else {
      navigation.navigate("BookingDetails", { bookingId: item.bookingId });
    }
  };


  const formatDate = (timestamp) => {
    const date = new Date(timestamp * 1000)
    const options = {
      day: "2-digit",
      month: "short",
      year: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    }
    return date.toLocaleString("en-US", options).replace(",", "-")
  }

  return (
    <View style={styles.container}>
      <TopGreenHeader Heading={'Notification'} navigation={navigation} isBackIcon={true} isNotification={true} />

      {loading ? (
        <ActivityIndicator size="large" color="#A6CE39" style={styles.loader} />
      ) : error ? (
        <Text style={styles.errorText}>{error}</Text>
      ) : (
        <ScrollView contentContainerStyle={styles.menuContainer}>
          {notifications.map((item) => (
            <TouchableOpacity onPress={() => { handlePress(item) }}>
              <View key={item.id} style={styles.menuItem}>
                <View style={styles.notificationContent}>
                  <Text style={styles.menuText}>{item.content} </Text>
                  <Text style={styles.timestampText}>{formatDate(item.createdAt)}</Text>
                </View>
                {(item.status === "ONGOING" || item.status === "COMPLETED") && (
                  <Image style={styles.starIcon} />
                )}
                {/* <Image source={require('./assets/next1.png')} style={styles.nextIcon} /> */}
              </View>
            </TouchableOpacity>
          ))}
        </ScrollView>
      )}
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#fff",
  },
  header: {
    backgroundColor: "#A6CE39",
    padding: 15,
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "center",
  },

  headerTitle: {
    fontSize: 30,
    fontFamily: Platform.OS === "android" ? "FacebookSansRegular" : "Facebook Sans",
    fontStyle: 'normal',
    fontWeight: 'bold',
    color: "#fff",

  },
  backButton: {
    position: "absolute",
    left: 20,
    top: 18,
  },
  backIcon: {
    width: 12,
    height: 24,
  },
  menuContainer: {
    paddingHorizontal: 16,
  },
  menuItem: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    paddingVertical: 14,
    borderBottomWidth: 1,
    borderBottomColor: "#E0E0E0",
  },
  notificationContent: {
    flex: 1,
    marginRight: 10,
  },
  menuText: {
    fontSize: 16,
    fontFamily: Platform.OS === "android" ? "FacebookSansRegular" : "Facebook Sans",
    fontStyle: 'normal',
    fontWeight: 'normal',
    color: "#333",
    marginBottom: 4,
  },
  timestampText: {
    fontSize: 14,
    fontFamily: Platform.OS === "android" ? "FacebookSansRegular" : "Facebook Sans",
    fontStyle: 'normal',
    fontWeight: 'normal',
    color: "#888",
  },
  nextIcon: {
    width: 12,
    height: 25,
    tintColor: "#000000",
  },
  starIcon: {
    width: 20,
    height: 20,
    tintColor: "#FF69B4",
  },
  loader: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },
  errorText: {
    color: "red",
    textAlign: "center",
    margin: 20,
    fontFamily: Platform.OS === "android" ? "FacebookSansRegular" : "Facebook Sans",
    fontStyle: 'normal',
    fontWeight: 'normal',
  },
})

export default Notification

